module.exports = __webpack_public_path__ + "static/img/shl_logo_small.18107a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_logo_small.png
// module id = +5eo
// module chunks = 5